export default __webpack_public_path__ + "static/media/virgen.981739dd.jpg";